import React from 'react'

const Banner = ({ title, text, className }) => {
    return (
        <div className={className}>
            {title && <h3>{title}</h3>}
            {text && <p>{text}</p>}
        </div>
    )
}

export default Banner